/**
 * Auth feature-local constants (ADR-0009): error codes the UI branches on and the
 * client-facing policy numbers. Cross-cutting values (route paths) live in
 * `@/config/routes`; these are auth-specific and exported via the feature barrel.
 */

/** Stable error codes returned by the admin auth realm (ADR-0008). Branch on these, never raw strings. */
export const AUTH_ERROR_CODES = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  ACCOUNT_TEMPORARILY_LOCKED: 'ACCOUNT_TEMPORARILY_LOCKED',
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
  INVALID_OTP: 'INVALID_OTP',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  RESEND_COOLDOWN_ACTIVE: 'RESEND_COOLDOWN_ACTIVE',
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
  ADMIN_NOT_FOUND: 'ADMIN_NOT_FOUND',
  INVALID_REFRESH_TOKEN: 'INVALID_REFRESH_TOKEN',
  RESET_TOKEN_EXPIRED: 'RESET_TOKEN_EXPIRED',
  PASSWORD_REUSED: 'PASSWORD_REUSED',
} as const;

export type AuthErrorCode = (typeof AUTH_ERROR_CODES)[keyof typeof AUTH_ERROR_CODES];

/** Client-facing auth policy. Server is the source of truth; these drive UI defaults/timers. */
export const AUTH_POLICY = {
  /** Idle inactivity timeout for non-remember-me sessions (story 101634). */
  idleMs: 20 * 60 * 1000,
  /** Default OTP resend cooldown when the server doesn't supply one. */
  resendCooldownSeconds: 60,
  /** Max OTP resends per challenge. */
  maxResends: 5,
} as const;
